import styled from "styled-components";

export default styled.button`
  border: 0;
  color: #fff;
  background: #38416b;
  padding: 10px;
  border-radius: 3px;
`;
